import React, { useState } from 'react';
import styled from 'styled-components';
import uuid from 'uuid';

import { Body1, H3 } from 'components/atoms/Text';
import { InputWithBorder } from 'components/molecules/TextInput';
import { CourseSetUpContainer, HeaderContainer } from 'components/organisms/CourseSetUp';
import InvitedUserTable from './InvitedUserTable';
import { message } from 'shell/components';
import { emailRegex } from 'utils/constants';

const StaffListContainer = styled.div`
    margin-top: 12px;
`;

const InviteAdditionalStaff = ({ fieldKeys, courseData = {}, handleInputChange, auth = {}, review = false }) => {
    const [newUser, setNewUser] = useState();

    const handleKeyDown = (e) => {
        if (e.key !== 'Enter') return;
        if (courseData[fieldKeys?.STAFF_LIST]?.some((staff) => staff.email === newUser))
            return message.error('The email already exists.');
        if (courseData[fieldKeys?.STUDENT_LIST].some((student) => student.email === newUser))
            return message.error('The email already exists in the list of student.');
        if (!emailRegex.test(newUser)) return message.error('Please enter a valid email.');
        const newStaffList = [...(courseData[fieldKeys?.STAFF_LIST] || []), { id: uuid.v4(), email: newUser?.trim() }];
        handleInputChange(fieldKeys?.STAFF_LIST, newStaffList);
        return setNewUser('');
    };

    return (
        <CourseSetUpContainer>
            <HeaderContainer review={review}>
                <H3>Invite Staff & Assistants</H3>
                <Body1 style={{ marginBottom: 25 }}>
                    Send an email invitation to any additional staff or assistants which you would like to forward a
                    link to access this course.
                </Body1>
            </HeaderContainer>
            <InputWithBorder
                error={false}
                errorMessage=''
                placeholder='e.g. john@ensightful.com'
                required={false}
                title='Invite By Email'
                value={newUser}
                onChange={(value) => setNewUser(value)}
                onKeyDown={(e) => handleKeyDown(e)}
            />
            <StaffListContainer>
                <InvitedUserTable
                    type={fieldKeys?.STAFF_LIST}
                    tableType={'instructor'}
                    userList={courseData[fieldKeys?.STAFF_LIST].filter((staff) => staff.id !== auth?.owner_account_id)}
                    handleInputChange={handleInputChange}
                    review={review}
                />
            </StaffListContainer>
        </CourseSetUpContainer>
    );
};

export default InviteAdditionalStaff;
